import React from 'react';
import PropTypes from 'prop-types';
import getContent from '../lib/dictionaryFetcher';

const MyAppCardItemOffer = props => {
  const { app, children } = props;

  const offerTitle = getContent(
      'merchanthub',
      `apps.${app}.info.offer.title`,
      ''
    ),
    offerDescription = getContent(
      'merchanthub',
      `apps.${app}.info.offer.description`,
      ''
    );

  if (!offerTitle && !offerDescription) return null;

  return (
    <div className="myapps-card-offer">
      <h4>{offerTitle}</h4>
      <p>{offerDescription}</p>
      {children}
    </div>
  );
};

MyAppCardItemOffer.propTypes = {
  children: PropTypes.node,
  app: PropTypes.string,
  btnType: PropTypes.string,
  btnText: PropTypes.string,
  onClick: PropTypes.func
};

export default MyAppCardItemOffer;
